import { Box, Heading, Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon, Text, Button, Link } from '@chakra-ui/react'; 

const faqs = [ { question: 'Where can I send and receive money with Swiftchang?', 
    answer: `You can transfer money with Swiftchang to multiple countries around the world including the US, UK, Canada, and Nigeria. We are expanding to more countries, so please check our website regularly for updated information and follow us on Social Media.`, },
    
    { question: 'How do I sign up for Swiftchang?', 
    answer: `Getting started with Swiftchang is quick and simple:

    1. Download the app from Google Play or the App Store.

    2. Create your free account using your email or phone number. 

    3. Create your password. 

    Once you're set up, you can enjoy competitive exchange rates, a secure platform, and fast delivery options for all your international transfers.`, }, 
   
    
    { question: 'How does Swiftchang work?', 
    answer: `After downloading the app and signing up for free with your email or phone number, choose the currency you want to transfer from and add money to the account. Choose the recipient's country and enter their details. Confirm the transfer and track its progress in the app.`, }, 
   
    { question: 'How long does a money transfer usually take?', 
    answer: `The delivery speed varies based on the recipient’s bank. However, most transfers deliver within minutes. For transfers between Swiftchang users or wallet-to-wallet currency conversion, delivery is instant.`, }, 
    
    { question: 'What are the fees for using Swiftchang?', 
    answer: `Swiftchang charges zero fees for all transactions.`, },

    { question: 'Why should I trust Swiftchang?', 
    answer: `Every time you choose Swiftchang, you're trusting us with your promises to loved ones. That trust drives us to continuously enhance our security and maintain the highest standards for your transfers.
    
    Swiftchang is fully licensed and regulated in every country we serve, adhering to stringent security and customer protection standards set by our regulatory authorities
    
    Swiftchang uses bank-level encryption, advanced technology, & predictive tools detect suspicious activity before it becomes a problem. We notify you instantly of any profile updates, ensuring you can verify that all changes were authorized by you.`, },

    
    { question: 'How much money can I send per transfer?', 
    answer: `The maximum amount you can send per transfer depends on several factors, including your account verification level and the recipient's country. Please check your profile for specific limits based on your situation.
    To view your transfer limits:

    1. Open the app and tap the menu icon in the top-left corner
    2. Select "Account Information" from the settings menu
    3. Click "Account Limits"
    4. Choose your desired currency to view applicable limits
    
    Note: Currency conversions between wallets count toward your transaction limits. Limits reset daily at 12 AM, weekly on Sundays at 12 AM, and monthly on the first day of each month (UTC timezone).`, },
]; 
    
export default function FaqSection() {
      return ( 
          <Box id="faq-section" backgroundColor="gray.800" py={20}> 
            <Box  maxW="800px" mx="auto" py={10} px={4}>
             <Heading as="h2" size="lg" mb={6} textAlign="center" color="white"> Swiftchang FAQs </Heading> 
             <Accordion allowToggle > 
                {faqs.map((faq, index) => ( 
                    
                    <AccordionItem key={index} border="none" mb={4}> 
                        <AccordionButton _expanded={{ bg: 'white' }} _hover={{ bg: 'gray.100' }} 
                            px={4} py={3} borderRadius="2xl" boxShadow="2xl" backgroundColor="white"> 
                            <Box flex="1" textAlign="left" fontWeight="medium"> {faq.question} </Box> 
                            <AccordionIcon /> 
                        </AccordionButton> 
                        
                        <AccordionPanel px={4} py={2} color="white"> 
                            <Text whiteSpace="pre-line">{faq.answer}</Text> 
                        </AccordionPanel> 
                    </AccordionItem> ))} 
            </Accordion> 
            <Box textAlign="center" mt={6}>
                <Link href="/help" _hover={{ textDecoration: 'none' }}>
                    <Button backgroundColor="white" color="black" size="md" borderRadius="2xl" boxShadow="lg" _hover={{ bg: 'gray.100' }}>
                        Search for your questions
                    </Button>
                </Link>
            </Box>
        </Box> 
    </Box> ); }